/**
 * Позиция корзины считается бесплатной, если скидка из корзины Битрикс (item.DISCOUNT)
 * покрывает её полную стоимость (например, подарочная конфета за опрос со скидкой 100%).
 *
 * item.DISCOUNT приходит от бэкенда за ЕДИНИЦУ товара (как и item.PRICE), поэтому сравниваем
 * с ценой единицы, не умножая на количество.
 *
 * Частичные скидки (купон, скидочная карта и т.п.) сюда не попадают - только полное покрытие.
 * Одна и та же проверка используется для строки товара, "ИТОГО" под списком и нижнего блока
 * стоимости заказа, чтобы суммы не расходились с тем, что видит пользователь в строках.
 */
export function isFreeItem(item) {
	const discount = Number(item.DISCOUNT) || 0;
	if (discount <= 0) return false;
	return discount >= Number(item.PRICE);
}
